import styled from 'styled-components';

import {
    getPurpurBorder,
    getPurpurColor,
    getPurpurSpacing,
    getPurpurTypography,
} from '@telialt/common-theme/src/purpurSelectors';

export const SuggestionsNoResultsWrapper = styled.div`
    width: 100%;
    background: ${getPurpurColor('gray50')};
    border-radius: ${getPurpurBorder('radiusMd')};
    padding: ${getPurpurSpacing('300')};
    color: ${getPurpurColor('textMedium')};
`;

export const HighlightedKeyword = styled.div`
    font-size: ${getPurpurTypography('scale400')};
    font-weight: ${getPurpurTypography('weightBold')};
    color: ${getPurpurColor('brandOffBlack')};
    margin-bottom: ${getPurpurSpacing('300')};
    word-break: break-word;
`;
